import { ArrowUpDown, ArrowLeftRight } from 'lucide-react'
import { Input, InputGroup as TwyneInputGroup, InputGroupText, DefaultTooltip } from 'twyne-new.ui'

import { useCraftProp } from '@/components/builder/utils'

const ICONS = {
  ArrowUpDown,
  ArrowLeftRight,
}

export default function InputGroupProperty({ options }) {
  return <div className='flex gap-1'>
    {options.map(item => <>
      <InputGroupItemProperty
        key={item.name}
        {...item}
      />
    </>)}
  </div>
}

function InputGroupItemProperty({ name, label, icon, content }) {
  const value = useCraftProp(name)
  const Icon = ICONS[icon]
  const Content = content ? content : <Icon size={14} />

  return <>
    <TwyneInputGroup variant='accent'>
      <DefaultTooltip content={label}>
        <InputGroupText addonType='prepend'>
           {Content}
        </InputGroupText>
      </DefaultTooltip>
      <Input
        type='text'
        size='sm'
        value={value.value}
        onChange={e => value.setValue(e.target.value)}
        onKeyDown={e => e.key === ',' && e.preventDefault()}
      />
    </TwyneInputGroup>
  </>
}
